const styles = (theme) => ({
  divider: {
    backgroundColor: theme.palette.neutral.lighter,
  },
  monthBox: {
    padding: '20px 20px',
  },
  monthListBox: {
    marginBottom: 40,
  },
});

export default styles;
